import { WA_NUMBER } from '../constants'

export default function DepartureRow({ dep }) {
  const available = dep.totalSpots - dep.filledSpots
  const full = available === 0
  const hot = available <= 2 && available > 0

  const spotsClass = full ? 'badge-red' : hot ? 'badge-amber' : 'badge-green'
  const spotsText = full ? 'Full — join waitlist' : hot ? `${available} spot${available > 1 ? 's' : ''} left` : `${available} spots available`

  const dateFormatted = new Date(dep.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })

  const waMsg = `Hi Lopsang, I want to join the ${dep.trek} departure on ${dateFormatted}. Is there still a spot available?`

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '16px',
      padding: '16px 20px',
      border: '1px solid var(--stone-mid)',
      borderRadius: 'var(--radius-lg)',
      background: 'var(--white)',
      flexWrap: 'wrap',
      transition: 'var(--transition)',
    }}
    onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--color-accent-cool)'; e.currentTarget.style.boxShadow = 'var(--shadow-sm)' }}
    onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--stone-mid)'; e.currentTarget.style.boxShadow = 'none' }}
    >
      <div style={{ fontFamily: 'var(--serif)', fontSize: '16px', fontWeight: 600, minWidth: '120px' }}>
        {dateFormatted}
      </div>
      <div style={{ fontSize: '13px', color: 'var(--ink-mid)', flex: 1, minWidth: '150px' }}>
        {dep.trek} · {dep.duration} days
      </div>

      {/* Spot dots */}
      <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
        {Array.from({ length: dep.totalSpots }).map((_, i) => (
          <div key={i} style={{
            width: '8px', height: '8px', borderRadius: '50%',
            background: i < dep.filledSpots ? 'var(--green)' : 'var(--stone-mid)',
          }} />
        ))}
      </div>

      <span className={`badge ${spotsClass}`}>{spotsText}</span>
      <div style={{ fontSize: '13px', fontWeight: 500, color: 'var(--green)', minWidth: '60px' }}>
        ${dep.price.toLocaleString()}
      </div>
      <a
        href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(waMsg)}`}
        target="_blank" rel="noreferrer"
        className="btn btn-green btn-sm"
        style={{ opacity: full ? 0.5 : 1, pointerEvents: full ? 'none' : 'auto' }}
      >
        {full ? 'Waitlist' : 'Join →'}
      </a>
    </div>
  )
}
